import { ConfigRoutes } from "../../shared/models/general/utils.interface";

interface AccesosArchivos {
    MANTENIMIENTO_TIPO_CAMBIO: ConfigRoutes
    REGISTRAR_TIPO_CAMBIO: ConfigRoutes
    MODIFICAR_TIPO_CAMBIO: ConfigRoutes
    ARTICULOS: ConfigRoutes
    MANTENIMIENTO_ARTICULOS: ConfigRoutes
    REGISTRAR_ARTICULOS: ConfigRoutes
    MODIFICAR_ARTICULOS: ConfigRoutes
    CONSULTA_ARTICULOS: ConfigRoutes
    CLASES_ARTICULOS: ConfigRoutes
    LISTA_PRECIOS_CLIENTES: ConfigRoutes
    LISTA_PRECIOS_PROVEEDORES: ConfigRoutes
    ARTICULOS_ISC: ConfigRoutes
    ARTICULOS_EXONERADOS: ConfigRoutes
    KANBAN: ConfigRoutes
    CLONAR_MERCADERIA: ConfigRoutes
    PROOVEDORES: ConfigRoutes
    MANTENIMIENTO_PROOVEDORES: ConfigRoutes
    CONSULTA_PROOVEDORES: ConfigRoutes
    CLIENTES: ConfigRoutes
    MANTENIMIENTO_CLIENTES: ConfigRoutes
    CONSULTA_CLIENTES: ConfigRoutes
    CLASES_CLIENTES: ConfigRoutes
    TRANSPORTISTA: ConfigRoutes
    PLAN_CUENTAS: ConfigRoutes
    SUBCENTRO_COSTO: ConfigRoutes
    MANTENIMIENTO_CONTACTOS: ConfigRoutes
}

interface ModuloArchivos {
    ID: number
    ACCESOS: AccesosArchivos
}

const pathModulo = '/archivos/'

export const MODULO_ARCHIVOS: ModuloArchivos = {
    ID: 0,
    ACCESOS: {
        MANTENIMIENTO_TIPO_CAMBIO: {
            TITLE: 'Tipo de cambio',
            ACCESS: 3,
            PATH_MODULE: pathModulo,
            DESCRI: 'Archivos - Mantenimiento de tipo de cambio',
            ROUTE: 'tipo-cambio'
        },
        REGISTRAR_TIPO_CAMBIO: {
            TITLE: 'Registrar tipo de cambio',
            ACCESS: 3,
            PATH_MODULE: pathModulo,
            DESCRI: 'Nuevo tipo de cambio',
            ROUTE: 'tipo-cambio'
        },
        MODIFICAR_TIPO_CAMBIO: {
            TITLE: 'Modificar tipo de cambio',
            ACCESS: 3,
            PATH_MODULE: pathModulo,
            DESCRI: 'Modificar tipo de cambio',
            ROUTE: 'tipo-cambio'
        },
        ARTICULOS: {
            TITLE: 'Artículos',
            ACCESS: 103
        },
        MANTENIMIENTO_ARTICULOS: {
            TITLE: 'Mantenimiento',
            ACCESS: 10301,
            PATH_MODULE: pathModulo,
            DESCRI: 'Archivos - Mantenimiento de artículos',
            ROUTE: 'mantenimiento-articulos'
        },
        REGISTRAR_ARTICULOS: {
            TITLE: 'Registrar artículo',
            ACCESS: 10301,
            PATH_MODULE: pathModulo,
            DESCRI: 'Nuevo artículo',
            ROUTE: 'registrar-articulos'
        },
        MODIFICAR_ARTICULOS: {
            TITLE: 'Modificar artículo',
            ACCESS: 10301,
            PATH_MODULE: pathModulo,
            DESCRI: 'Modificar artículo',
            ROUTE: 'modificar-articulos'
        },
        CONSULTA_ARTICULOS: {
            TITLE: 'Consulta',
            ACCESS: 10301,
            PATH_MODULE: pathModulo,
            DESCRI: 'Archivos - Consulta de artículos',
            ROUTE: 'consulta-articulos'
        },
        CLASES_ARTICULOS: {
            TITLE: 'Clases',
            ACCESS: 10303,
            PATH_MODULE: pathModulo,
            DESCRI: 'Archivos - Consulta de clases de artículos',
            ROUTE: 'clases-articulos'
        },
        LISTA_PRECIOS_CLIENTES: {
            TITLE: 'Lista de precios de clientes',
            ACCESS: 10304,
            PATH_MODULE: pathModulo,
            DESCRI: 'Archivos - Lista de precios de clientes',
            ROUTE: 'lista-precios-clientes'
        },
        LISTA_PRECIOS_PROVEEDORES: {
            TITLE: 'Lista de precios de proveedores',
            ACCESS: 10305,
            PATH_MODULE: pathModulo,
            DESCRI: 'Archivos - Lista de precios de proveedores',
            ROUTE: 'lista-precios-proveedores'
        },
        ARTICULOS_ISC: {
            TITLE: 'Artículos con ISC',
            ACCESS: 10306,
            PATH_MODULE: pathModulo,
            DESCRI: 'Archivos - Lista de artículos con ISC',
            ROUTE: 'lista-articulos-isc'
        },
        ARTICULOS_EXONERADOS: {
            TITLE: 'Artículos exonerados',
            ACCESS: 10307,
            PATH_MODULE: pathModulo,
            DESCRI: 'Archivos - Lista de artículos exonerados',
            ROUTE: 'lista-articulos-exonerados'
        },
        KANBAN: {
            TITLE: 'Kanban',
            ACCESS: 10307,
            PATH_MODULE: pathModulo,
            DESCRI: 'Archivos - Kanban',
            ROUTE: 'kanban'
        },
        CLONAR_MERCADERIA: {
            TITLE: 'Clonar mercadería',
            ACCESS: 106,
            PATH_MODULE: pathModulo,
            DESCRI: 'Archivos - Clonar mercadería',
            ROUTE: 'clonar-mercaderia'
        },
        PROOVEDORES: {
            TITLE: 'Proveedores',
            ACCESS: 203
        },
        MANTENIMIENTO_PROOVEDORES: {
            TITLE: 'Mantenimiento',
            ACCESS: 20302,
            PATH_MODULE: pathModulo,
            DESCRI: 'Archivos - Mantenimiento de proveedores',
            ROUTE: 'mantenimiento-proovedores'
        },
        CONSULTA_PROOVEDORES: {
            TITLE: 'Consulta',
            ACCESS: 20302,
            PATH_MODULE: pathModulo,
            DESCRI: 'Archivos - Consulta de proveedores',
            ROUTE: 'consulta-proovedores'
        },
        CLIENTES: {
            TITLE: 'Clientes',
            ACCESS: 303
        },
        MANTENIMIENTO_CLIENTES: {
            TITLE: 'Mantenimiento',
            ACCESS: 30302,
            PATH_MODULE: pathModulo,
            DESCRI: 'Archivos - Mantenimiento de clientes',
            ROUTE: 'mantenimiento-clientes'
        },
        CONSULTA_CLIENTES: {
            TITLE: 'Consulta',
            ACCESS: 30302,
            PATH_MODULE: pathModulo,
            DESCRI: 'Archivos - Consulta de clientes',
            ROUTE: 'consulta-clientes'
        },
        CLASES_CLIENTES: {
            TITLE: 'Clases',
            ACCESS: 30303,
            PATH_MODULE: pathModulo,
            DESCRI: 'Archivos - Consulta de clases de clientes',
            ROUTE: 'clases-clientes'
        },
        TRANSPORTISTA: {
            TITLE: 'Transportista',
            ACCESS: 20302,
            PATH_MODULE: pathModulo,
            DESCRI: 'Archivos - Mantenimiento de transportistas',
            ROUTE: 'mantenimiento-transportistas'
        },
        PLAN_CUENTAS: {
            TITLE: 'Plan de cuentas',
            ACCESS: 20302,
            PATH_MODULE: pathModulo,
            DESCRI: 'Archivos - Mantenimiento de plan de cuentas',
            ROUTE: 'mantenimiento-plan-cuentas'
        },
        SUBCENTRO_COSTO: {
            TITLE: 'Subcentro de costo',
            ACCESS: 20302,
            PATH_MODULE: pathModulo,
            DESCRI: 'Archivos - Mantenimiento de subcentro de costos',
            ROUTE: 'mantenimiento-subcentro-costo'
        },
        MANTENIMIENTO_CONTACTOS: {
            TITLE: 'Contactos',
            ACCESS: 20302,
            PATH_MODULE: pathModulo,
            DESCRI: 'Archivos - Mantenimiento de contactos',
            ROUTE: 'mantenimiento-contactos'
        },
    }
}

const EXCLUIDOS_BUSQUEDA = ['REGISTRAR_TIPO_CAMBIO', 'MODIFICAR_TIPO_CAMBIO', 'REGISTRAR_ARTICULOS', 'MODIFICAR_ARTICULOS']

export const MODULO_ARCHIVOS_BUSQUEDA = Object.entries(MODULO_ARCHIVOS.ACCESOS)
  .filter(item => item[1].DESCRI != null && !EXCLUIDOS_BUSQUEDA.includes(item[0]))
